import { IGetProfessionalCountsByLocationParams } from '../types/IGetProfessionalCountsByLocationParams';
import { IGetProfessionalCountsParams } from '../types/IGetProfessionalCountsParams';
import { IGetProfessionalProfileParams } from '../types/IGetProfessionalProfileParams';
import { IProfessionalCountsResponse } from '../types/IProfessionalCountsResponse';
import { IProfessionalProfile } from '../types/IProfessionalProfile';
import { GetProfessionalCountsClient } from '../clients/GetProfessionalCounts';
import { GetProfessionalProfileClient } from '../clients/GetProfessionalProfile';
import { professionalProfileAdapter } from '../adapters/professionalProfileAdapter';

export const ProfessionalsService = {
  getProfessionalCountsByOffice: (
    params: IGetProfessionalCountsParams,
  ): Promise<IProfessionalCountsResponse> =>
    GetProfessionalCountsClient.getProfessionalCountsByOffice(params),

  getProfessionalCountsByLocation: (
    params: IGetProfessionalCountsByLocationParams,
  ): Promise<IProfessionalCountsResponse> =>
    GetProfessionalCountsClient.getProfessionalCountsByLocation(params),

  getProfessionalProfile: async (
    params: IGetProfessionalProfileParams,
  ): Promise<IProfessionalProfile> =>
    professionalProfileAdapter.toProfessionalProfile(
      await GetProfessionalProfileClient.getProfessionalProfile(params),
    ),
};
